import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { AlertComponent } from './alert/alert.component'
import { ButtonComponent } from './button/button.component'
import { LoadingComponent } from './loading/loading.component';
import { GenericHeaderComponent } from './generic-header/generic-header.component';

// Eliminamos las declaraciones de componentes que ahora son standalone
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        AlertComponent,
        ButtonComponent,
        LoadingComponent,
        ReactiveFormsModule,
        GenericHeaderComponent
    ],
    exports: [
        AlertComponent,
        ButtonComponent,
        LoadingComponent,
        TranslateModule,
        CommonModule,
        FormsModule,
        GenericHeaderComponent
    ],
    declarations: [
      
    ]
})
export class ComponentsModule { }
